import type { CSSProperties } from "react";

type IconProps = { size?: number; className?: string; style?: CSSProperties };

function Icon({ size, className, style, d }: IconProps & { d: string }) {
  return (
    <svg
      width={size ?? 20}
      height={size ?? 20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <path d={d} />
    </svg>
  );
}

export const IconDashboard = (p: IconProps) =>
  Icon({ ...p, d: "M3 3h7v7H3zm0 11h7v7H3zm11-11h7v7h-7zm0 11h7v7h-7z" });

export const IconTenants = (p: IconProps) =>
  Icon({ ...p, d: "M3 21h18M5 21V7l8-4 8 4v14M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01" });

export const IconOperators = (p: IconProps) =>
  Icon({ ...p, d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" });

export const IconAudit = (p: IconProps) =>
  Icon({ ...p, d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8" });

export const IconLogout = (p: IconProps) =>
  Icon({ ...p, d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4m7 14 4-4-4-4m4 4H3" });

export const IconSearch = (p: IconProps) =>
  Icon({ ...p, d: "M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0z" });

export const IconLoader = (p: IconProps) =>
  Icon({ ...p, d: "M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48 2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48 2.83-2.83" });

export const IconAlert = (p: IconProps) =>
  Icon({ ...p, d: "M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4m0 4h.01" });

export const IconCheck = (p: IconProps) =>
  Icon({ ...p, d: "M20 6 9 17l-5-5" });

export const IconBranch = (p: IconProps) =>
  Icon({ ...p, d: "M3 21h18M5 21V7l8-4 8 4v14" });

export const IconWarehouse = (p: IconProps) =>
  Icon({ ...p, d: "M2 20h20M4 20V10l8-4 8 4v10" });

export const IconCatalog = (p: IconProps) =>
  Icon({ ...p, d: "M4 7V4h16v3M9 20h6M12 4v16" });

export const IconOrders = (p: IconProps) =>
  Icon({ ...p, d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0" });

export const IconCustomers = (p: IconProps) =>
  Icon({ ...p, d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9.5 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87" });

export const IconEmployees = (p: IconProps) =>
  Icon({ ...p, d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9.5 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" });

export const IconDevice = (p: IconProps) =>
  Icon({ ...p, d: "M12 18h.01M8 21h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2z" });

export const IconLicense = (p: IconProps) =>
  Icon({ ...p, d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM4 11a8 8 0 0 0 16 0" });

export const IconInvoice = (p: IconProps) =>
  Icon({ ...p, d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8" });

export const IconReceipt = (p: IconProps) =>
  Icon({ ...p, d: "M4 4v16l3-2 3 2 3-2 3 2 3-2 2 2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z" });

export const IconShift = (p: IconProps) =>
  Icon({ ...p, d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" });

export const IconAttendance = (p: IconProps) =>
  Icon({ ...p, d: "M12 7v5l3 3M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" });

export const IconInventory = (p: IconProps) =>
  Icon({ ...p, d: "M12 3l9 4.5-9 4.5-9-4.5L12 3zm0 9v9m-9-4.5V8.25L12 12m9-3.75V13.5L12 12" });

export const IconStock = (p: IconProps) =>
  Icon({ ...p, d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" });
